/**************************************************************************************************/
/*   File: /src/app/stores/actions/messages/messages.action.ts                                    */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';

import * as fromShared from '../../../shared';
import { ElementRef } from '@angular/core';

/**
 * The messages action types enum
 */
export enum MessagesActionsType {
  SHOW_CONFIRM_DIALOG_OPEN = '[Messages] Show confirm dialog component',
  REMOVE_MESSAGE_ACTION = '[Messages] Remove message',
  NOTIFY_MESSAGE = '[Messages] Notify message'
}

/**
 * The action used to show confirm dialog
 */
export class ShowConfirmDialogAction {
  /**
   * The type
   */
  readonly type = MessagesActionsType.SHOW_CONFIRM_DIALOG_OPEN;

  /**
   * The constructor
   * @param payload The payload containing the confirm data
   */
  constructor(public payload: { elementRef: ElementRef }) { }

}

/**
 * Remove message action
 */
export class RemoveMessageAction implements Action {
  /**
   * The type
   */
  readonly type = MessagesActionsType.REMOVE_MESSAGE_ACTION;

  /**
   * The constructor of remove message action
   * @param payload The payload is the id of the message
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}

/**
 * Notify message action
 */
export class NotifyMessage implements Action {
  /**
   * The type
   */
  readonly type = MessagesActionsType.NOTIFY_MESSAGE;

  /**
   * The constructor of Notify message action
   * @param payload The payload is the message
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}

/**
 * The messages actions type
 */
export type MessagesActions = ShowConfirmDialogAction | RemoveMessageAction | NotifyMessage;
